import Vue from 'vue'
import Vuex from 'vuex'
import searchModule from './searches'
import userModule from './users'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    search: searchModule,
    user: userModule
  }
})
